import { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CommentEditorSource } from '../redux/types';
import { CommentEditorContext, EditorContext } from '../context';
import { useEditorDraftActions } from './useEditorDraftActions';
import { useIsCommentEditorEmpty } from './useIsCommentEditorEmpty';
/**
 * Provides a function that will cancel a comment! Completely! It'll be removed from drafts
 * and we'll close the relevant editor.
 *
 * Relies on all the contexts provided by `<CommentEditorProviders />`,
 * so be sure you have it set up first!
 */
export function useCommentCancelAction(_a) {
    var _b = _a === void 0 ? {} : _a, onCancel = _b.onCancel;
    var t = useTranslation().t;
    var _c = useContext(CommentEditorContext), editorId = _c.editorId, editorSource = _c.editorSource, collapseEditor = _c.collapseEditor;
    var editorApi = useContext(EditorContext).api;
    var removeEditorDraft = useEditorDraftActions(editorId).removeEditorDraft;
    var isEmpty = useIsCommentEditorEmpty();
    return useCallback(function () {
        removeEditorDraft();
        if (editorSource !== CommentEditorSource.Edit && !isEmpty) {
            var cancel = confirm(t('commentbox.editor.cancel.confirm'));
            if (!cancel) {
                return;
            }
            editorApi === null || editorApi === void 0 ? void 0 : editorApi.clearEditor(true);
        }
        collapseEditor();
        onCancel && onCancel();
    }, [
        isEmpty,
        editorSource,
        removeEditorDraft,
        t,
        editorApi,
        onCancel,
        collapseEditor,
    ]);
}
//# sourceMappingURL=useCommentCancelAction.js.map